export default __webpack_public_path__ + "static/media/Boots of the Living Tarim.c2a7504c.jpg";